import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef } from "react";
import { Container, Grid, Typography, Box } from "@mui/material";

import Radio from "@/components/ph/Radio";

import FormSection from "../../utils/FormSection";

import { setFormValue, setValidValue } from "../../contractor/contractorSlice";

import { validateField } from "../hooks/fieldRules";

const DriverRadioField = () => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.contractor.formValues);
  const driverFormValues = useSelector((state) => state.driver.formValues);

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current && formValues.esConductorHabitual === "Si") {
      const driverValues = driverFormValues || {};
      const contractorFields = [
        "primerApellido",
        "segundoApellido",
        "nombres",
        "fechaNacimiento",
        "genero",
      ];

      contractorFields.forEach((field) => {
        const value = driverValues[field] || "";
        dispatch(setFormValue({ field, value }));

        const { isValid } = validateField(field, value);
        dispatch(setValidValue({ field, isValid }));
      });

      hasInitialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value) => {

    dispatch(setFormValue({ field: "esConductorHabitual", value }));

    if (value === "No") {
      const fieldsToReset = [
        "primerApellido",
        "segundoApellido",
        "nombres",
        "fechaNacimiento",
        "genero",
        "rfc",
        "regimenFiscal",
      ];

      hasInitialized.current = false;

      fieldsToReset.forEach((field) => {
        dispatch(setFormValue({ field, value: "" }));
        const { isValid } = validateField(field, "");
        dispatch(setValidValue({ field, isValid }));
      });
    } else if (value === "Si") {
      const driverValues = driverFormValues || {};

      const contractorFields = [
        "primerApellido",
        "segundoApellido",
        "nombres",
        "fechaNacimiento",
        "genero",
      ];

      contractorFields.forEach((field) => {
        const value = driverValues[field] || "";
        dispatch(setFormValue({ field, value }));

        const { isValid } = validateField(field, value);
        dispatch(setValidValue({ field, isValid }));
      });

      const contractorOnlyFields = ["rfc"];

      contractorOnlyFields.forEach((field) => {
        dispatch(setFormValue({ field, value: "" }));
        const { isValid } = validateField(field, "");
        dispatch(setValidValue({ field, isValid }));
      });

      hasInitialized.current = true;
    }
  };

  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
      <FormSection>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Box
                sx={{
                  minHeight: "3.5rem",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "text.secondary",
                    mt: 1,
                    fontSize: "1rem",
                  }}
                >
                  ¿El Contratante es el mismo que el conductor habitual?
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Box
                sx={{
                  minHeight: "3.5rem",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Radio
                  name="esConductorHabitual"
                  value="Si"
                  label="Si"
                  checked={formValues.esConductorHabitual === "Si"}
                  onChange={handleChange}
                />
                <Radio
                  value="No"
                  label="No"
                  name="esConductorHabitual"
                  checked={formValues.esConductorHabitual === "No"}
                  onChange={handleChange}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </FormSection>
    </Container>
  );
};

export default DriverRadioField;
